/* istanbul ignore file */
import { SET_MONTH } from './actionTypes'

export const setMonth = month => {
  return {
    type: SET_MONTH,
    month
  }
}
